import { h } from "preact";

import IconProps from "./IconProps";

interface Props extends IconProps {
    transparent?: boolean;
}

function IconDelete({ color, width, height, transparent }: Props) {
    return (
        <svg width={width} height={height}>
            <path
                fill={color}
                fill-rule="evenodd"
                d="M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14zm0-8.292L5.059 3.766a.918.918 0 0 0-1.29.003.91.91 0 0 0-.003 1.29L5.708 7 3.766 8.941a.918.918 0 0 0 .003 1.29.91.91 0 0 0 1.29.003L7 8.292l1.941 1.942a.918.918 0 0 0 1.29-.003.91.91 0 0 0 .003-1.29L8.292 7l1.942-1.941a.918.918 0 0 0-.003-1.29.91.91 0 0 0-1.29-.003L7 5.708z"/>
            <path
                fill={transparent ? "transparent" : "#fff"}
                d="M7 5.708L5.059 3.766a.918.918 0 0 0-1.29.003.91.91 0 0 0-.003 1.29L5.708 7 3.766 8.941a.918.918 0 0 0 .003 1.29.91.91 0 0 0 1.29.003L7 8.292l1.941 1.942a.918.918 0 0 0 1.29-.003.91.91 0 0 0 .003-1.29L8.292 7l1.942-1.941a.918.918 0 0 0-.003-1.29.91.91 0 0 0-1.29-.003L7 5.708z"/>
        </svg>
    );
}

IconDelete.defaultProps = {
    color: "var(--gandalf)",
    width: 14,
    height: 14
};

export default IconDelete;
